<div class="row h-100">
	<div class="col-lg-4 col-12 h-100">
		<div class="jmGridsterItem h-100">
			<app-interest-survey></app-interest-survey>
		</div>
	</div>
	<div class="col-lg-4 col-12 jmProgressItem">
		<div class="jmGridsterItem h-100">
			<app-skill-profiler></app-skill-profiler>
		</div>
	</div>
	<div class="col-lg-4 col-12 jmProgressItem">
		<div class="jmGridsterItem h-100">
			<app-begin-career-exploration></app-begin-career-exploration>
		</div>
	</div>
</div>
